import { memo } from "react";

interface DetailFieldProps {
  label: string;
  children: React.ReactNode;
  /** Vrijednost preko cijele širine mreže — npr. opis ili metapodaci. */
  wide?: boolean;
}

/** Oznaka iznad vrijednosti, za kartice s detaljima vrste obrade i obrade. */
const DetailField: React.FC<DetailFieldProps> = ({ label, children, wide }) => (
  <div className={wide ? "col-span-full" : ""}>
    <div className="text-xs uppercase tracking-wide text-slate-400 mb-1">{label}</div>
    <div className="text-sm text-slate-800">{children}</div>
  </div>
);

export default memo(DetailField);
